module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/logo01-6e288424a763229431bdcca353cdad2b.png";